import { RefObject, useLayoutEffect, useState } from 'react';

export function useContainerWidth(containerRef: RefObject<HTMLElement>) {
  const [containerWidth, setContainerWidth] = useState<number | null>(null);

  // Ensure we pick up the width once the referenced element is mounted and on every resize after that.
  // We re-run the effect whenever `containerRef.current` changes from `null` → actual element (or vice-versa).
  useLayoutEffect(() => {
    const element = containerRef.current;

    if (!element) {
      if (containerWidth !== null) {
        setContainerWidth(null);
      }
      return;
    }

    const updateWidth = () => {
      const newWidth = element.clientWidth;
      if (newWidth !== containerWidth && newWidth > 0) {
        // Ensure newWidth is positive
        setContainerWidth(newWidth);
      }
    };

    updateWidth();
    const resizeObserver = new ResizeObserver(updateWidth);
    resizeObserver.observe(element);

    return () => {
      resizeObserver.disconnect();
    };
    // containerRef.current dependency is the only reliable way this effect knows that the DOM node stored in the ref has been replaced, yet still has the same width.
    // eslint-disable-next-line exhaustive-deps-with-refs/exhaustive-deps
  }, [containerRef.current, containerWidth]);

  return containerWidth;
}
